import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Button from '../../components/Button';
import Loader from '../../components/Loader';
import OtherContent from '../../components/OtherContent';
import { __ } from '../../utilities';
import { loadOtherContentById } from '../App/actions';
import {
  otherContentContentSelector,
  otherContentIsFetchingSelector,
  otherContentNameSelector,
} from '../App/selectors';
import { locale } from '../LocaleProvider';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 50.0625rem;
  margin: 0 auto;
`;

const ButtonLink = styled.a`
  text-decoration: none;
`;

const MainText = styled.div`
  font-size: ${rem(40)};
  color: ${({ theme }) => theme.color.primary};
  margin: ${rem(70)} 0;
  text-align: center;
  font-weight: 500;
`;

const NotDeliveredMail = styled.div`
  margin-bottom: 0.625rem;
  width: 100%;
  max-width: ${rem(400)};
`;

class ErrorPayment extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(loadOtherContentById('RESERVATION_PAYMENT_FAIL'));
  }

  render() {
    const {
      otherContentIsFetching,
      otherContentName,
      otherContent,
    } = this.props;

    if (otherContentIsFetching) {
      return <Loader size="xl" />;
    }

    return (
      <Wrapper>
        <MainText>{otherContentName}</MainText>
        <NotDeliveredMail>
          <OtherContent content={otherContent} />
        </NotDeliveredMail>

        <br />

        <ButtonLink
          href={`${process.env.REACT_APP_API_BASE_URL}/${locale.lang}`}
        >
          <Button primary>{__('Naspäť na hlavnú stránku')}</Button>
        </ButtonLink>

        <br />
        <br />
      </Wrapper>
    );
  }
}

ErrorPayment.propTypes = {
  dispatch: PropTypes.func.isRequired,
  otherContent: PropTypes.string.isRequired,
  otherContentName: PropTypes.string.isRequired,
  otherContentIsFetching: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  otherContentName: otherContentNameSelector('RESERVATION_PAYMENT_FAIL')(state),
  otherContent: otherContentContentSelector('RESERVATION_PAYMENT_FAIL')(state),
  otherContentIsFetching: otherContentIsFetchingSelector(
    'RESERVATION_PAYMENT_FAIL',
  )(state),
});

export default connect(mapStateToProps)(ErrorPayment);



// WEBPACK FOOTER //
// ./src/containers/Payment/Nok.js